export default {
  name: 'pageNotFound',
  components: {
  },
  props: {
    data: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {},
  mixins: [],
  data () {
    return {}
  },
  methods: {},
  mounted () {}
}
